import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RejeitarPlanoModal from './rejeitarplanomodal'
import { clearRejeitarPlano, fetchMotivosRejeicao, rejeitarPlano } from './redux/rejeitarplanoActions'
import './rejeitarplano.scss'

const RejeitarPlano = ({
  open,
  close,
  planoId,
  ciclo,
  nomePlano,
  onSuccess
}) => {
  const dispatch = useDispatch()
  const { sistema } = useSelector(state => state.layoutState)
  const { loadingMotivos, loadingSubmit, motivos, error } = useSelector(
    state => state.pdcaState.pdcaRejeitarPlanoState
  )

  const [motivoSelecionado, setMotivoSelecionado] = useState({})
  const [comentario, setComentario] = useState('')

  const nls = require(`./nls/${sistema.idioma}.json`)

  useEffect(() => {
    if (open && planoId && ciclo) {
      dispatch(fetchMotivosRejeicao(ciclo))
    }
  }, [dispatch, open, planoId, ciclo])

  useEffect(() => {
    if (open && motivos.length > 0 && !motivoSelecionado?.value) {
      setMotivoSelecionado(motivos[0])
    }
  }, [open, motivos, motivoSelecionado])

  useEffect(() => {
    if (!open) {
      setMotivoSelecionado({})
      setComentario('')
      dispatch(clearRejeitarPlano())
    }
  }, [dispatch, open])

  useEffect(() => {
    if (open && error && !loadingMotivos && !loadingSubmit) {
      setMotivoSelecionado({})
      setComentario('')
      dispatch(clearRejeitarPlano())
      close()
    }
  }, [dispatch, open, error, loadingMotivos, loadingSubmit, close])

  const handleClose = () => {
    setMotivoSelecionado({})
    setComentario('')
    dispatch(clearRejeitarPlano())
    close()
  }

  const handleChangeMotivo = e => {
    setMotivoSelecionado(e?.value || {})
  }

  /*
  const handleChangeComentario = e => {
    setComentario(e.target.value)
  }
  */
  const handleChangeComentario = e => {
    setComentario(e.value || '')
  }




  const handleConfirmar = async () => {
    if (!motivoSelecionado?.value) {
      return
    }

    const sucesso = await dispatch(
      rejeitarPlano({
        ciclo,
        planoId,
        motivoCodigo: motivoSelecionado.value,
        comentario
      })
    )

    if (sucesso) {
      dispatch(clearRejeitarPlano())
      setMotivoSelecionado({})
      setComentario('')
      onSuccess()
    }
  }

  return (
    <RejeitarPlanoModal
      open={open}
      close={handleClose}
      nls={nls}
      nomePlano={nomePlano}
      motivos={motivos}
      motivoSelecionado={motivoSelecionado}
      comentario={comentario}
      loadingMotivos={loadingMotivos}
      loadingSubmit={loadingSubmit}
      onChangeMotivo={handleChangeMotivo}
      onChangeComentario={handleChangeComentario}
      onConfirmar={handleConfirmar}
    />
  )
}

export default RejeitarPlano